import { render, staticRenderFns } from "./ConfigContainerPackingBlock.vue?vue&type=template&id=12bd0e8a&scoped=true"
import script from "./ConfigContainerPackingBlock.vue?vue&type=script&lang=ts"
export * from "./ConfigContainerPackingBlock.vue?vue&type=script&lang=ts"
import style0 from "./ConfigContainerPackingBlock.vue?vue&type=style&index=0&id=12bd0e8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bd0e8a",
  null
  
)

export default component.exports